<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :color="'#f18f00'"
      :is-full-page="false"
      :height="100"
      :width="255"
      :opacity="0.8"
      class="custom-loading-dash"
    >
    </loading>
    <div
      class="wrapper wrapper-full-page d-flex justify-content-center align-items-center flex-nowrap flex-column"
    >
      <div class="full-page" :data-color="backgroundColor" :class="pageClass">
        <div :class="`content ${contentClass}`" :style="styleContent">
          <div class="container">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
    styleContent: {
      type: String,
      default: '',
    },
    pageClass: {
      type: String,
      default: 'login-page',
    },
    backgroundColor: {
      type: String,
      default: 'smart-page',
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.navbar-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.wrapper-full-page .navbar-toggler,
.wrapper-full-page .navbar-collapse .navbar-nav {
  margin-right: 30px;
}
.navbar-collapse .navbar-nav .nav-link {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
